export function detectAudioSupport() {
  if (typeof window === "undefined") {
    return { canOgg: false, canAac: true };
  }

  const audio = document.createElement("audio");
  const canOgg = !!audio.canPlayType('audio/ogg; codecs="vorbis"');
  const canAac =
    !!audio.canPlayType('audio/mp4; codecs="mp4a.40.2"') ||
    !!audio.canPlayType("audio/aac");

  return { canOgg, canAac };
}

export function getAudioContextClass() {
  if (typeof window === "undefined") return null;
  // @ts-ignore webkit
  return window.AudioContext || window.webkitAudioContext || null;
}

export function decodeAudioBuffer(context, arrayBuffer) {
  return new Promise((resolve, reject) => {
    try {
      context.decodeAudioData(
        arrayBuffer,
        decoded => resolve(decoded),
        err => reject(err)
      );
    } catch (error) {
      const maybePromise = context.decodeAudioData(arrayBuffer);
      if (maybePromise && typeof maybePromise.then === "function") {
        maybePromise.then(resolve).catch(reject);
      } else {
        reject(error);
      }
    }
  });
}
